import { render } from "./PatientPrescriber.vue?vue&type=template&id=1851ab4b"
import script from "./PatientPrescriber.vue?vue&type=script&lang=js"
export * from "./PatientPrescriber.vue?vue&type=script&lang=js"

import "./PatientPrescriber.vue?vue&type=style&index=0&id=1851ab4b&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__